<!-- date-hour-service-form.component.html -->
<div>
  <div class="summary-information-box gap-10 fw-600 d-flex flex-column">
    <label for="pickup-date">{{ 'pickup_day' | translate }}</label>

    <div class="calendar-picker-container w-100">
      <input type="text" class="form-control calendar-picker" #dp="bsDatepicker" bsDatepicker
        [daysDisabled]="calendarDisabledDays" [minDate]="today" [bsConfig]="bsConfig"
        [datesDisabled]="getNormalizedBlockedDates()" autocomplete="off" [bsValue]="selectedDate"
        (bsValueChange)="onPickupDateChange($event)" required placeholder="DD/MM/YYYY" />
      <div class="calendar-icon"></div>
    </div>
  </div>

  <ng-container *ngIf="!isTransit()">
    <div class="pickup-hour gap-15 d-flex flex-column mg-t15" *ngIf="selectedDate && !onlySpecificHour">
      <div class="summary-information-box gap-10 fw-600 d-flex flex-column" *ngIf="shouldShowHourModeSelector()">
        <label for="pickup-date">{{ 'pickupTime' | translate }}</label>

        <div class="select-container w-100">
          <div class="custom-select padding-left" (click)="toggleSpecificHoursDropdown()" tabindex="0" role="combobox"
            [attr.aria-expanded]="isSpecificHoursDropdownOpen" [attr.aria-controls]="'specific-hours-options'">
            <span class="selected-option">
              {{
              isSpecificHours
              ? ('scheduleWithSpecificTimesPrice1' | translate)
              : ('scheduleWithTimeSlots' | translate)
              }}
            </span>
            <div class="chevron" [class.open]="isSpecificHoursDropdownOpen"></div>
          </div>

          <div class="options-container" *ngIf="isSpecificHoursDropdownOpen" id="specific-hours-options">
            <div class="options-scroll">
              <div class="option" (click)="selectSpecificHours(false)" tabindex="0" role="option"
                [attr.aria-selected]="!isSpecificHours">
                {{ 'scheduleWithTimeSlots' | translate }}
              </div>

              <div class="option" (click)="selectSpecificHours(true)" tabindex="0" role="option"
                [attr.aria-selected]="isSpecificHours">
                {{ 'scheduleWithSpecificTimesPrice1' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- RANGE HOURS -->
    <div class="d-flex flex-column justify-content-between gap-15 mg-t15"
      *ngIf="selectedDate && !isSpecificHours && !noAvailableHours && availableStartHours.length && availableEndHours.length">
      <div class="d-flex justify-content-between w-100 gap-15">
        <div class="summary-information-box gap-10 fw-600 d-flex flex-column w-100">
          <label for="pickupTime">{{ 'from' | translate }}</label>
          <app-dropdown-select [DataArray]="availableStartHours" [KeyName]="['Text']" [KeyId]="'Key'"
            [SelectedObject]="selectedStartHour" [Placeholder]="('from_placeholder' | translate)"
            (optionEmitter)="selectPickupTime($event)"></app-dropdown-select>
        </div>

        <div class="summary-information-box gap-10 fw-600 d-flex flex-column w-100">
          <label for="endHour">{{ 'until' | translate }}</label>
          <app-dropdown-select [DataArray]="availableEndHours" [KeyName]="['Text']" [KeyId]="'Key'"
            [disabled]="noAvailableEndHours || selectedStartHour == null" [SelectedObject]="selectedEndHour"
            [Placeholder]="('to_placeholder' | translate)"
            (optionEmitter)="selectEndHour($event)"></app-dropdown-select>
        </div>
      </div>
    </div>

    <!-- SPECIFIC HOUR -->
    <div class="time-selector w-100 gap-10 d-flex flex-column mg-t15"
      *ngIf="selectedDate && isSpecificHours && !noAvailableHours">
      <label class="summary-information-box fw-600" for="pickup-date">{{ 'pickupTime' | translate }}</label>

      <div class="custom-select-container">
        <button class="custom-select custom-select-hour" type="button" (click)="toggleDropdown()">
          {{ selectedHourPair ? selectedHourPair.displayText : ('selectHour' | translate) }}
        </button>

        <div class="custom-options" [ngClass]="{ show: showDropdown }">
          <div *ngFor="let hour of availableHours" [class.selected]="hour === selectedHourPair"
            [class.disabled]="hour.disabled" (click)="selectHour(hour)" class="custom-option">
            {{ hour.displayText }}

            <div class="quota-container" *ngIf="shouldShowQuota(hour)">
              {{ getQuotaText(hour) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div *ngIf="noAvailableHours" class="no-hours-message">
    {{ 'noAvailableHoursMessage' | translate }}
  </div>

  <div *ngIf="noAvailableEndHours" class="warning-message no-hours-message">
    {{ warningMessage }}
  </div>
</div>